/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2107
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.InputRowType = undefined;
(function (e) {
  e[e.INLINE = -1] = "INLINE"
  e[e.STATEMENT = 3] = "STATEMENT"
})(exports.InputRowType || (exports.InputRowType = {}))
